// extracted by mini-css-extract-plugin
module.exports =  {"mobile-header":"eK1h6GX","mobileHeader":"eK1h6GX"};